import { TherapistInfoDto } from '../../../../shared/dtos/therapist.dto';
import { FC, ReactElement } from 'react';
import AppModal from '../app-modal/AppModal';
import { Modal } from 'react-bootstrap';
import i18next from 'i18next';
import ChangeTherapistForm from './ChangeTherapistForm';
import { ChangeTherapist } from './PatientsTable';

type ChangeTherapistModalProps = {
  show: boolean;
  therapists: TherapistInfoDto[];
  data: ChangeTherapist,
  onClose: () => void;
  onSave: () => void;
}

const ChangeTherapistModal: FC<ChangeTherapistModalProps> = ({
  show,
  therapists,
  data,
  onClose,
  onSave,
}: ChangeTherapistModalProps): ReactElement => {
  
  return (
    <AppModal show={show} onHide={onClose} backdrop="static" keyboard>
      <Modal.Header closeButton>
        <Modal.Title>
          {i18next.t('changeTherapistModal.title')}
        </Modal.Title>
      </Modal.Header>
            
      <Modal.Body>
        <span className="d-block pb-5">{i18next.t('changeTherapistModal.info')}</span>
        <ChangeTherapistForm 
          data={data} 
          therapistInfos={therapists} 
          onClose={onClose} 
          onSubmit={() => {
            onSave();
            onClose();
          }}
        />
      </Modal.Body>
    </AppModal>
  );
};

export default ChangeTherapistModal;
